<template>
  <v-card v-if="1===2 && showPermissions"
          class="mb-4">
    <v-card-title>
      Permissions
    </v-card-title>
    <v-card-text>

      <v-switch v-if="team.scanner_enabled"
                v-model="form.scanner_enabled"
                label="Can use the business card scanner"
                hide-details
                class="mt-0">
      </v-switch>

      <v-switch v-if="team.builder_enabled"
                v-model="form.can_use_builder"
                label="Can use the presentation builder"
                hide-details
                class="mt-0">
      </v-switch>

    </v-card-text>
  </v-card>
</template>
<script>
import {mapGetters} from 'vuex';

export default {
  props: {
    form: {
      type: Object,
      required: true,
    },
    user: {
      type: Object,
      required: false,
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters([
      'activeUsers',
      'countries',
      'currentUser',
      'groups',
      'isAdmin',
      'isMember',
      'locales',
      'team',
      'teamRoles',
      'timezones',
    ]),
    showPermissions() {
      if (!this.isAdmin) {
        return false;
      }
      return this.team.builder_enabled
        || this.team.scanner_enabled;
    },
    isCurrentUser() {
      return this.user
        && this.currentUser.id === this.user.id;
    }
  },
}
</script>
